import React from "react";

/**
 * Placeholder destination for the "Return to Qualtrics" button on the
 * checkout confirmation, used while the server's QUALTRICS_RETURN_URL is
 * not set (see buildQualtricsReturnUrl in helpers/experiment.js).
 */
function Done() {
  return (
    <div id="done-page">
      Done
    </div>
  );
}

export default Done;
